import { Heading } from "@solomon-apps/shared/src/components/ui/heading";
import { cn } from "@solomon-apps/shared/src/utils/cn";
import { motion } from "motion/react";
import React from "react";

/**
 * Shared page chrome for the YaaS Client Console pages.
 *
 * Every section page (Dashboard / Positions / Admin / Reporting / Policies /
 * Add Position / Edit Position) opens with the same scaffold: a fade-up
 * `motion.div` around the page header (with bottom rule) and its children.
 * This component captures that recipe so each page just declares its title,
 * optional actions, and body content.
 */
export interface ClientPageProps {
    title: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
    /** Optional className applied to the outermost motion.div. */
    className?: string;
}

export function ClientPage({
    title,
    actions,
    children,
    className
}: ClientPageProps): React.ReactElement {
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className={cn("flex flex-col pt-6 w-full", className)}
        >
            <Heading
                asElement="header"
                title={title}
                actions={actions}
                className="px-6 pb-6 border-b border-line-base"
            />
            {children}
        </motion.div>
    );
}
